// The job page's map of its address (BL-018, maps package 6): ui-web's JobPage draws it in Site, under
// the address, through its siteMap slot. It's the address's point from jobs.page (the job as jobs.get
// has it), on Google's map with the session's key (the stand-in with none), where the point came from,
// and Navigate in Google Maps; with no point yet it says "No pin yet". Site writes the address above
// it, so the map leaves it off. Inside a .flw part, as AddressOnMap's drawing is.
import type { ReactNode } from 'react';
import { AddressOnMap } from '../shared/AddressOnMap.tsx';
import type { JobDetail } from '../review/review-model.ts';

export function jobSiteMap(job: Pick<JobDetail, 'address' | 'point'>): ReactNode {
  if (!job.address) return undefined;
  return (
    <div className="flw">
      <AddressOnMap address={job.address} point={job.point} showAddress={false} />
    </div>
  );
}
